<template>
  <div>
    <div
      class="field-container w-full rounded-5 flex items-center shrink-0 relative h-50 text-14 pl-10 pr-14"
      :class="[error ? 'field-error' : '']" style="background: #2b4f14;box-shadow:0 4px 8px rgba(0,0,0,0.05); "
    >
      <div
        class="h-full flex items-center flex-1 shrink-0 relative overflow-hidden"
      >
        <slot name="left"></slot>
        <input
          v-model="inputValue"
          :type="inputType"
          class="h-full flex-1 text-color-white text-13 ml-10 font-700"
          :placeholder="placeholderValue"
          @blur="handleBlur"
          @input="handleInput"
        />
        <button
          v-if="inputValue"
          @click="inputValue = ''"
          class="text-color-2 text-12 flex items-center justify-center ml-12"
        >
          <i
            class="inline-block h-[max-content] w-[max-content] icon sysicon-new-clean-1"
          ></i>
        </button>
        <button
          v-if="type === 'password'"
          @click="handleChangeType"
          class="text-color-2 text-16 flex items-center justify-center ml-10"
        >
          <i
            class="inline-block h-[max-content] w-[max-content] icon sysicon-new-eyes-close cursor-pointer"
            :class="[
              inputType === 'password'
                ? 'sysicon-new-eyes-close'
                : 'sysicon-new-eyes-open'
            ]"
          ></i>
        </button>
        <slot name="right"></slot>
      </div>
    </div>
    <div class="text-left text-12 mt-2 text-color-tip-3" v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { computed, reactive, ref, watch } from "vue";
const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: [String, Number, Object],
    default: ""
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: {
    type: String,
    default: ""
  },
  error: {
    type: String,
    default: ""
  }
});
const inputType = ref(props.type);
const placeholderValue = computed(() => {
  return props.placeholder || t("A0346");
});
// 计算属性，用于双向绑定
const inputValue = computed({
  get() {
    return props.modelValue; // 绑定 modelValue 的值
  },
  set(value) {
    emit("update:modelValue", value); // 当输入框内容变化时，更新父组件的值
  }
});
const emit = defineEmits(["update:modelValue", "onblur", "oninput"]);

// watch(
//   () => props.type,
//   nv => {
//     if (nv) {
//       inputType.value = nv;
//     }
//   }
// );
function handleBlur(e) {
  emit("onblur", e);
}
function handleInput(e) {
  emit("oninput", e);
}
function handleChangeType() {
  inputType.value = inputType.value === "password" ? "text" : "password";
}
</script>
<style scoped></style>
